
  <div class="about-section">
  <div class="container">
    <div class="row align-items-center m-1">
      <!-- Left Side: Text -->
      <div class="col-md-7 col-12 about-text">
        <h2>The Dance Program</h2>
        <!-- <h3>Diverse Avenues for Discovery and Growth</h3> -->
        <p>
          The Dance Program at Innovative Vision is designed to be more than just a class;
          it's a celebration of movement, rhythm, and self-expression. Through various dance forms,
          we aim to develop a child's confidence, coordination, and creativity in a joyful and 
          supportive environment. Our program is a holistic journey that nurtures the mind, body, and soul.
        </p>
      </div>
      <!-- Right Side: Image -->
      <div class="col-md-5 col-12 text-center about-img">
        <img src="assets/ivimg/programDetails/danceH.svg" alt="Girl Learning Pottery" class="img-fluid">
      </div>
    </div>
  </div>
</div>
<div class="key-focus-section m-3">
  <div class="image-container">
    <img src="assets/ivimg/programDetails/danseF.svg" alt="Key Focus Areas"/>
  </div>
  <div class="content">
    <h2 class="section-title">Key Focus Areas</h2>
    <div class="points">
      <p>
        <strong>1. Gross Motor Skills & Coordination:</strong>
        Our curriculum focuses on enhancing fundamental physical attributes. 
        Through a variety of movements, children will improve their coordination, 
        balance, flexibility, and rhythm. These skills are vital for all physical 
        activities and contribute to a healthy and active lifestyle.
      </p>
      <p>
        <strong>2. Creativity & Self-Expression:</strong> 
        Dance provides a unique platform for children to express themselves without words. 
        The program encourages improvisation and creative movement, helping to stimulate 
        the right brain and foster creativity, intuition, and emotional intelligence.
      </p>
      <p>
        <strong>3. Confidence & Social Skills:</strong> 
        Performing in front of others, even in a small group setting, builds immense confidence. 
        Our classes also promote teamwork and social interaction, as children learn to move in sync 
        and support their peers, fostering a strong sense of community.
      </p>
    </div>
  </div>
</div>


<div class="program-highlights">
  <div class="highlight-container">
    <!-- Image from assets -->
    <div class="image-container">
      <img src="assets/ivimg/PD-2.svg" alt="Program Highlights" />
    </div>

    <!-- Text Content -->
    <div class="text-container">
      <h2 class="title">Program Highlights</h2>
      <p>
        <strong>Structured Curriculum:</strong> Our program follows a well-defined, outcome-based curriculum with a clear progression of skills.
      </p>
      <p>
        <strong>Diverse Dance Forms:</strong> We introduce children to a variety of dance styles, from contemporary to traditional, ensuring a well-rounded exposure to different cultural and expressive forms.
      </p>
      <p>
        <strong>Play-Based Approach:</strong> Our sessions are filled with fun games and imaginative exercises that make learning dance an exciting and engaging experience. This approach ensures children remain enthusiastic about the program and develop a lifelong love for movement.
      </p>
    </div>
  </div>
</div> 


<div class="benefits-section">
  <h2 class="benefits-title">Benefits for Your Child</h2>
  <p class="benefits-text">
   Our dance program offers a multitude of benefits, including improved physical health,
    enhanced mental focus, and better social skills. By mastering new dance moves and 
    performing in front of others, children develop a strong sense of accomplishment and 
    self-worth. The rhythmic and creative nature of dance also helps in stimulating the 
    right side of the brain, which is key for spatial awareness and non-linear thinking. 
    This program is a journey of self-discovery, 
   helping your child find joy in movement and confidence in their own unique expression.
  </p>
</div>
